import React from 'react';

// Donut da COMPOSIÇÃO da carteira (por ativo, ponderado pelo valor em fiat). SVG puro, sem dependência.
// Deixa a tela menos "tabela crua" — o usuário vê de relance como o capital está distribuído.
const COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#a855f7', '#ef4444', '#06b6d4', '#84cc16', '#ec4899'];
const fmt = n => (Number(n) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });

function WalletDonut({ balances, fiat = 'USD' }) {
    const items = (balances || [])
        .map(b => ({ symbol: b.symbol, value: parseFloat(b.fiatEstimate) || 0 }))
        .filter(i => i.value > 0)
        .sort((a, b) => b.value - a.value);
    const total = items.reduce((s, i) => s + i.value, 0);
    if (total <= 0) return null;

    // Top 6 + "Outros" (agrupa a cauda pra não poluir).
    const TOP = 6;
    let segs = items;
    if (items.length > TOP) {
        const rest = items.slice(TOP).reduce((s, i) => s + i.value, 0);
        segs = [...items.slice(0, TOP), { symbol: 'Outros', value: rest }];
    }

    const R = 52, C = 2 * Math.PI * R, cx = 60, cy = 60, sw = 16;
    let before = 0;
    const arcs = segs.map((s, i) => {
        const len = (s.value / total) * C;
        const arc = { ...s, color: COLORS[i % COLORS.length], dash: `${len} ${C - len}`, off: -before, pct: (s.value / total) * 100 };
        before += len;
        return arc;
    });

    return (
        <div className='d-flex align-items-center flex-wrap gap-4 mb-3'>
            <svg width='120' height='120' viewBox='0 0 120 120' style={{ flex: '0 0 auto' }}>
                <circle cx={cx} cy={cy} r={R} fill='none' stroke='#e9ecef' strokeWidth={sw} />
                {arcs.map((a, i) => (
                    <circle key={i} cx={cx} cy={cy} r={R} fill='none' stroke={a.color} strokeWidth={sw}
                        strokeDasharray={a.dash} strokeDashoffset={a.off}
                        transform={`rotate(-90 ${cx} ${cy})`} />
                ))}
                <text x={cx} y={cy - 1} textAnchor='middle' fontSize='15' fontWeight='bold' fill='#212529'>{items.length}</text>
                <text x={cx} y={cy + 13} textAnchor='middle' fontSize='9' fill='#6c757d'>ativo{items.length > 1 ? 's' : ''}</text>
            </svg>
            <div style={{ minWidth: 200 }}>
                <div className='text-muted small mb-1'>Composição da carteira ({fiat})</div>
                {arcs.map((a, i) => (
                    <div key={i} className='d-flex align-items-center justify-content-between' style={{ fontSize: 13 }}>
                        <span>
                            <span className='d-inline-block rounded-circle me-2' style={{ width: 9, height: 9, background: a.color, verticalAlign: 'middle' }} />
                            {a.symbol}
                        </span>
                        <span className='text-muted ms-3'>{a.pct.toFixed(1)}% · {fmt(a.value)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default WalletDonut;
